import {
  Component,
  Input,
  Injectable,
  OnDestroy,
  ElementRef,
  Renderer2,
  ViewChild,
  ViewEncapsulation,
} from "@angular/core";
import {
  chevronDown,
  folderOpen,
  save,
  edit,
  trash,
  slidersHorizontal,
  VAIconRegistryService,
  infoCircle,
  circle,
} from "@va/core-library/icons";
import { PharmaDataService } from "../pharma-data.service";
import { NzMessageService } from "ng-zorro-antd/message";
import { Router } from "@angular/router";
import { FacetFilter, extraInfoKeys } from "../pharma-page.model";
import { AppState, stateGetter } from "src/app/store/state/app.state";
import { Store } from "@ngrx/store";
import { FilterEventChanged } from "src/app/store/actions/pharma-page.actions";
import { Subscription } from "rxjs";
@Component({
  selector: "app-save-and-pills",
  templateUrl: "./save-and-pills.component.html",
  styleUrls: ["./save-and-pills.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
@Injectable({
  providedIn: "root",
})
export class SaveAndPillsComponent implements OnDestroy {
  selectedSavedFilter;
  // isViewMore = true;
  // isOverflowing = false;
  @ViewChild("div1", { static: true }) div1Ref!: ElementRef;
  // @ViewChild('div2', { static: true }) div2Ref!: ElementRef;

  @Input() siderCollapsed: boolean;

  savedFilterList = [];
  currentFilterObj: any;
  lastSavedFilterObj: any;
  setFilterObj: any;
  deletedFilterObj: any;
  showSavedFilterModal = false;
  savedFilterError = false;
  filterNameError = false;
  loadingSavedFilters = false;
  currentFilterName = "";
  displayFilterName = "Unnamed";
  showChangeBadge = false;
  showSaveAsNameModal = false;
  showDeleteModal = false;
  defaultFilterName = "My Filter";
  pharmaDatabasePageSubscriber: Subscription;
  updateFilterSubscriber: Subscription;
  saveFilterSubscriber: Subscription;
  getAllSavedFilterSubscriber: Subscription;
  deleteFilterSubscriber: Subscription;
  nameError: any;

  constructor(
    private iconRegistryService: VAIconRegistryService,
    private router: Router,
    private message: NzMessageService,
    private service: PharmaDataService,
    private store: Store<AppState>,
    private renderer: Renderer2,
  ) {
    this.iconRegistryService.registerIcons([
      save,
      folderOpen,
      chevronDown,
      slidersHorizontal,
      edit,
      trash,
      infoCircle,
      circle,
    ]);
  }
  ngOnInit() {
    this.showSavedFilterModal = false;
    this.pharmaDatabasePageSubscriber = this.store
      .select(stateGetter("pharmaDatabasePage"))
      .subscribe((data: any) => {
        this.setFilterObj = data.facetFilters;
        this.currentFilterObj = { ...this.setFilterObj };
        if (data.filterEvent.source === "new-search") {
          this.displayFilterName = "Unnamed";
          this.showChangeBadge = false;
          this.selectedSavedFilter = data.savedFilter;
          return;
        }
        if (data.filterEvent.source === "saved-filter") {
          this.selectedSavedFilter = data.savedFilter;
          this.lastSavedFilterObj = this.selectedSavedFilter.json_data;
          this.setFilterObj = { ...this.selectedSavedFilter.json_data };
          this.displayFilterName = this.selectedSavedFilter.filter_name;
          this.showChangeBadge = false;
          return;
        }

        if (
          data &&
          data.facetFilters &&
          this.checkIfFiltersAreApplied(data.facetFilters)
        ) {
          if (data.savedFilter.filter_id === null) {
            this.displayFilterName = "Unnamed";
          }
        }

        if (data.savedFilter.filter_id !== null) {
          if (
            data.filterEvent.filterChanged === "facet" ||
            data.filterEvent.filterChanged === "chart" ||
            data.filterEvent.filterChanged === "pill"
          ) {
            this.showChangeBadge = true;
          }
        }
      });
  }

  checkIfFiltersAreApplied(filters) {
    if (!filters) return false;
    for (const filter in filters) {
      if (filters[filter].length > 0) return true;
    }
    return false;
  }
  onSave() {
    if (this.selectedSavedFilter && this.selectedSavedFilter.filter_id) {
      if (this.showChangeBadge) {
        //update existing filter
        const payload = {
          filter_id: this.selectedSavedFilter.filter_id,
          json_data: this.currentFilterObj,
          page_name: "database",
        };
        if (this.updateFilterSubscriber) {
          this.updateFilterSubscriber.unsubscribe();
        }
        this.updateFilterSubscriber = this.service
          .updateFilterObject(payload)
          .subscribe((resp) => {
            if (resp.update_status === "success") {
              this.message.success(
                `Filter ${this.selectedSavedFilter.filter_name} updated `,
              );
              this.selectedSavedFilter.json_data = { ...this.currentFilterObj };
              this.lastSavedFilterObj = this.selectedSavedFilter.json_data;
              this.setFilterObj = { ...this.selectedSavedFilter.json_data };
              this.service.logUserAction(
                "UPDATE_FILTER",
                this.selectedSavedFilter,
              );
              this.showChangeBadge = false;
            } else {
              this.message.error(resp.error_message);
            }
          });
      }
    } else {
      const payload = {
        filter_name: this.defaultFilterName,
        json_data: !this.currentFilterObj
          ? { ...this.setFilterObj }
          : { ...this.currentFilterObj },
        page_name: "database",
      };
      if (this.saveFilterSubscriber) {
        this.saveFilterSubscriber.unsubscribe();
      }
      this.saveFilterSubscriber = this.service
        .saveCurrentFilter(payload)
        .subscribe(
          (resp) => {
            if (resp.status === "success") {
              this.message.success(`${resp.filter_name} saved.`);
              this.selectedSavedFilter = {
                filter_id: resp.filter_id,
                filter_name: resp.filter_name,
                json_data: payload.json_data,
              };
              this.displayFilterName = resp.filter_name;
              this.showChangeBadge = false;
              this.service.logUserAction(
                "SAVE_FILTER",
                this.selectedSavedFilter,
              );
              this.router.navigate([`/biopharma/database/user`], {
                queryParams: { filterId: resp.filter_id },
              });
            } else {
              this.message.error(
                "Something went wrong. Please try again later.",
              );
            }
          },
          () => {
            this.message.error("Something went wrong. Please try again later.");
          },
        );
    }
  }
  onOpen() {
    this.showSavedFilterModal = true;
    this.savedFilterError = false;
    this.loadingSavedFilters = true;
    this.getAllSavedFilterSubscriber = this.service
      .getAllSavedFilters()
      .subscribe(
        (response) => {
          if (response.status === "success") {
            this.savedFilterList = response.data;
          } else {
            this.savedFilterError = true;
          }
          this.loadingSavedFilters = false;
        },
        () => {
          this.savedFilterError = true;
        },
      );
  }
  toggleEditMode($event, data) {
    $event.stopPropagation();
    data.inEditMode = !data.inEditMode;
    if (data.inEditMode) {
      this.currentFilterName = data.filter_name;
      this.selectedSavedFilter = data;
    }
    if (!data.inEditMode) {
      this.editFilterName(data);
    }
  }
  onNameChange(dataObj) {
    if (this.currentFilterName.trim() === "") {
      this.filterNameError = true;
      this.nameError = "Name can not be blank";
      return;
    }
    const filterName = this.savedFilterList
      .filter((val) => {
        return val.filter_id !== dataObj.filter_id;
      })
      .map((val) => val.filter_name);
    if (filterName.indexOf(this.currentFilterName) > -1) {
      this.filterNameError = true;
      this.nameError = "Same name exists";
      return;
    }
    this.filterNameError = false;
  }
  editFilterName(dataObj) {
    if (this.filterNameError) {
      return;
    }
    this.currentFilterName = this.currentFilterName.trim();
    this.displayFilterName =
      this.displayFilterName === dataObj.filter_name
        ? this.currentFilterName
        : this.displayFilterName;
    dataObj.filter_name = this.currentFilterName;
    const payload = {
      filter_id: dataObj.filter_id,
      filter_name: this.currentFilterName,
      page_name: "database",
    };
    if (this.updateFilterSubscriber) {
      this.updateFilterSubscriber.unsubscribe();
    }
    this.updateFilterSubscriber = this.service
      .updateFilterObject(payload)
      .subscribe((resp) => {
        if (resp.update_status === "success") {
          this.message.success(
            `Filter name updated to : ${dataObj.filter_name}`,
          );
        }
      });
  }
  handleSavedFilterCancel() {
    this.showSavedFilterModal = false;
  }
  onRevertToLastSaved() {
    this.setFilterObj = this.lastSavedFilterObj;
    this.currentFilterObj = this.lastSavedFilterObj;
    this.showChangeBadge = false;
    if (this.selectedSavedFilter && this.selectedSavedFilter.filter_id) {
      this.store.dispatch(
        new FilterEventChanged({
          filterChanged: "facet",
          source: "saved-filter",
          data: {
            facetFilters: this.setFilterObj,
            savedFilter: this.selectedSavedFilter,
            extraInfo: this.service.getPharmaStateExtraInfo(extraInfoKeys, {}),
            fromQueryFilter: true,
          },
        }),
      );
    }
  }
  onReset() {
    const currentUrl = window.location.pathname;
    //Raise dummy facet change event to clear chart filters in database-page componenrt
    if (currentUrl === `/biopharma/database`) {
      this.setFilterObj = new FacetFilter().toDTO();
      this.currentFilterObj = this.setFilterObj;
      // this.displayFilterName = "";
      this.displayFilterName = "Unnamed";
      setTimeout(() => {
        this.store.dispatch(
          new FilterEventChanged({
            filterChanged: "facet",
            source: "default",
            data: {
              facetFilters: new FacetFilter().toDTO(),
              savedFilter: {
                filter_id: null,
                filter_name: "",
                json_data: {},
              },
              extraInfo: this.service.getPharmaStateExtraInfo(
                extraInfoKeys,
                {},
              ),
            },
          }),
        );
      }, 10);
    } else this.router.navigate([`/biopharma/database`]);
  }
  onSaveAs() {
    //show popup for name
    this.currentFilterName = "";
    this.showSaveAsNameModal = true;
  }
  handleSaveAsCancelModal() {
    this.showSaveAsNameModal = false;
    this.currentFilterName = "";
  }
  handleSaveAsOkModal() {
    const payload = {
      filter_name: this.currentFilterName,
      json_data: !this.currentFilterObj
        ? { ...this.setFilterObj }
        : { ...this.currentFilterObj },
      page_name: "database",
    };
    if (this.saveFilterSubscriber) {
      this.saveFilterSubscriber.unsubscribe();
    }
    this.saveFilterSubscriber = this.service
      .saveCurrentFilter(payload)
      .subscribe(
        (resp) => {
          if (resp.status === "success") {
            this.message.success(`${payload.filter_name} saved.`);
            this.selectedSavedFilter = {
              filter_id: resp.filter_id,
              filter_name: resp.filter_name,
              json_data: payload.json_data,
            };
            this.displayFilterName = resp.filter_name;
            this.showChangeBadge = false;
            this.service.logUserAction(
              "SAVE_AS_FILTER",
              this.selectedSavedFilter,
            );
            this.router.navigate([`/biopharma/database/user`], {
              queryParams: { filterId: resp.filter_id },
            });
          } else {
            this.message.error("Something went wrong. Please try again later.");
          }
        },
        () => {
          this.message.error("Something went wrong. Please try again later.");
        },
      );
    this.showSaveAsNameModal = false;
  }
  closeDeleteModal() {
    this.showDeleteModal = false;
  }
  showDeleteAlertModal($event, data) {
    $event.stopPropagation();
    data.inEditMode = false;
    this.deletedFilterObj = { ...data };
    this.showDeleteModal = true;
  }
  deleteFilter() {
    this.deleteFilterSubscriber = this.service
      .deleteSavedFilter(this.deletedFilterObj.filter_id)
      .subscribe((resp) => {
        if (resp.status === "success") {
          this.message.info(
            `Filter ${this.deletedFilterObj.filter_name} deleted successfully.`,
          );
          // remove it for all filter list
          this.savedFilterList = this.savedFilterList.filter(
            (val) => val.filter_id !== this.deletedFilterObj.filter_id,
          );
          if (
            this.selectedSavedFilter.filter_id ===
            this.deletedFilterObj.filter_id
          ) {
            this.onReset();
          }
        } else {
          this.message.error("Something went wrong. Please try again later.");
        }
      });
    this.closeDeleteModal();
  }
  selectFilter(data) {
    this.handleSavedFilterCancel();
    //change route to load saved filter
    this.router.navigate([`/biopharma/database/user`], {
      queryParams: { filterId: data.filter_id },
    });
  }
  removeWhiteSpaces(str: string): string {
    return str.trim();
  }

  ngOnDestroy(): void {
    if (this.pharmaDatabasePageSubscriber) {
      this.pharmaDatabasePageSubscriber.unsubscribe();
    }
    if (this.updateFilterSubscriber) {
      this.updateFilterSubscriber.unsubscribe();
    }
    if (this.saveFilterSubscriber) {
      this.saveFilterSubscriber.unsubscribe();
    }
    if (this.getAllSavedFilterSubscriber) {
      this.getAllSavedFilterSubscriber.unsubscribe();
    }
    if (this.deleteFilterSubscriber) {
      this.deleteFilterSubscriber.unsubscribe();
    }
  }
}
